import { SUPPORTED_UPLOAD_TYPES } from 'common/enum/supported-upload-types'

export const UPLOAD_CONFIG = {
  MAX_FILE_SIZE: 20 * 1024 * 1024,
  MAX_RETRIES: 3,
  INITIAL_BACKOFF: 1000,
  POLLING_MAX_ATTEMPTS: 3,
  POLLING_INITIAL_DELAY_MS: 1000,
  POLLING_INTERVAL_MS: 4000,
  SUPPORTED_UPLOAD_TYPES
} as const

export const ERROR_MESSAGES = {
  FILE_TOO_LARGE: 'File size exceeds 20MB limit',
  UNSUPPORTED_FILE_TYPE:
    'File type not supported. Accepted: PDF, JPEG, PNG, WebP',
  UPLOAD_FAILED: 'Upload failed after multiple attempts',
  URL_EXPIRED: 'Upload URL expired. Please try again',
  NETWORK_ERROR: 'Network error. Please check your connection',
  UNAUTHORIZED: 'Authentication required',
  INVALID_REQUEST: 'Invalid request parameters'
} as const
